export const colorPrimary = "#3E7D79";
export const colorSecondary = "#7FAEA8";
export const colorSecondary_2 = "#4ea7a9";
export const colorBorder = "#3E7D79";
export const colorAdditional = "#F0F0F7";
export const colorTextAdditional = "#00007A";

export const colorError = "#7FAEA8";

export const colorWhite = "#F7F3EE";
export const colorBlack = "#2E3A39";

export const colorAuthBackground = "#F7F3EE";

export const colorInputBorder = "#777777";
export const colorInputBorderGrayish = "#dadada";

export const colorGrayText = "rgba(0,0,0,.5)";
export const colorfff = "#FFFFFF";
